import gql from 'graphql-tag';

const query = gql`
  query Motivation {
    mindfulnessBalance {
      categories {
        id
        type
        position
        scenes {
          id
          title
          type
          audioUrl
          audioDuration
          imageUrl
          videoUrl
          isFeatured
          customIdentifier
          playbackMetadata {
            lastPlaybackPosition
            isPlaybackCompleted

            ... on ParentScenePlaybackMetadata {
              lastPlayedSubSceneId
              lastPlaybackPosition
              isPlaybackCompleted
            }
          }
          __typename

          ... on PodcastScene {
            description
          }
        }
      }
    }
  }
`;

export default query;
